import {
  GET_PROFILE_DATA,
  TOGGLE_SIDE_MENU,
} from "../actions/profileSettingsAction";

const initialState = {
  profileSettings_data: {},
  isToggleSideMenu: false,
};

export default function profileSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PROFILE_DATA:
      return {
        ...state,
        profileSettings_data: action.payload,
      };
      break;
    case TOGGLE_SIDE_MENU:
      return {
        ...state,
        isToggleSideMenu: action.payload,
      };
      break;
    default:
      return state;
  }
}
